import React, { FC, memo, useCallback, useMemo } from "react";
import { Icon } from "@material-ui/core";
import styles from "./Key.module.scss";
import { ReactComponent as ShiftIcon } from "../../../assets/icons/shift.svg";
import { ReactComponent as Backspace } from "../../../assets/icons/backspace.svg";
import type { ScreenStore } from "application/contexts/screen/ScreenStore";
import {
  OrientationType,
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";

interface KeyProps {
  onClick: (key: string) => void;
  children: string;
  type: "number" | "letter" | "password";
  disable?: boolean;
}

export const Key: FC<KeyProps> = memo((props) => {
  const resolution = useScreenStore((s: ScreenStore) => s.resolution);
  const orientation = useScreenStore((s: ScreenStore) => s.orientation);

  const { onClick, children: keyValue, type, disable } = props;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onClick(keyValue);
    },
    [onClick, keyValue]
  );

  const buttonStyle = useMemo<React.CSSProperties>(() => {
    const isNumberLike = type === "number" || type === "password";

    return {
      visibility: keyValue ? "visible" : "hidden",
      backgroundColor:
        keyValue === "check"
          ? "#2DA04C"
          : keyValue === "back-space" && type === "number"
          ? "#e0e0e0"
          : keyValue === "clear"
          ? "#e0e0e0"
          : "#fff",
      width: "100%",
      height: isNumberLike
        ? resolution === ResolutionType.FULL_HD
          ? orientation === OrientationType.PORTRAIT
            ? 150
            : 100
          : 70
        : 75,
      boxShadow: isNumberLike
        ? "0px 4px 12px 0px rgba(0, 0, 0, 0.10)"
        : "0px 1.451px 0px 0px rgba(0, 0, 0, 0.30)",
      fontSize: keyValue.length > 1 ? 22 : 30,
      color: keyValue === "check" || keyValue === "back-space" ? "#fff" : "unset",
    };
  }, [keyValue, orientation, resolution, type]);

  return (
    <button
      onClick={handleClick}
      type="button"
      disabled={disable}
      className={styles.keyContainer}
      style={buttonStyle}
    >
      {keyValue === "back-space" ? (
        type === "letter" ? (
          <Backspace />
        ) : (
          <Icon style={{ color: "#333333" }} fontSize="large">
            backspace
          </Icon>
        )
      ) : keyValue === "clear" ? (
        <div>LIMPAR</div>
      ) : keyValue === "check" ? (
        <Icon fontSize="large">check</Icon>
      ) : keyValue === "shift" ? (
        <ShiftIcon />
      ) : keyValue === " " ? (
        <Icon>space_bar</Icon>
      ) : (
        keyValue
      )}
    </button>
  );
});
